import axios from "axios";
import { baseURL } from "@/config.js";

export const axiosIns = axios.create({baseURL});
export const hostname = window.location.hostname.replace('www.','').split('.')[0];
// export const hostname = 'emporio-bienes-y-capitales-sas';
